<div class="form-group" [formGroup]="pricingForm">
    <h3>Pricing</h3>

    <div class="form-row">
        <div class="form-group col-lg-2">
          <app-dc-input-number-percent-indicative-final
            [label]="labels.pricingFairValue"
            [id]="'fairValue'"
            formControlName="pricingFairValue"
            [defaultUnit]="fieldToggle"
            [readonly]="fairValue['readOnly']"
          ></app-dc-input-number-percent-indicative-final>
        </div>
    </div>
    <div class="form-row" *ngIf="economicValue.enabled">
        <div class="form-group col-lg-2">
        <app-dc-input-number-percent-indicative-final
            [label]="labels.pricingEconomicValue"
            [id]="'economicValue'"
            formControlName="pricingEconomicValue"
            [readonly]="economicValue.readonly"
            [defaultUnit]="fieldToggle"
        ></app-dc-input-number-percent-indicative-final>
        </div>
    </div>
    <div class="form-row">
        <div class="form-group col-lg-2">
          <app-dc-input-number-percent-indicative-final
            [label]="labels.pricingReofferPrice"
            [id]="'reofferPrice'"
            formControlName="pricingReofferPrice"
            [defaultUnit]="fieldToggle"
            [readonly]="reofferPrice['readOnly']"
          ></app-dc-input-number-percent-indicative-final>
        </div>
    </div>
</div>